import * as Yup from 'yup';
import { CurrencyRateData } from '../hooks/useCurrencyConversionRate';
import { addError } from '@shared/utils/logger';

/**
 * Yup schema for validating CurrencyRateData structure
 */
const currencyRateDataSchema: Yup.Schema<CurrencyRateData> = Yup.object({
  exchangeRate: Yup.number().required(),
  taxesAndFeesMultiplier: Yup.number().required(),
  fixedCostPerCardInMinorUnits: Yup.number().required(),
});

/**
 * Parses currencyConversionData JSON from an order into CurrencyRateData format.
 * Returns undefined if the data is null, undefined, or invalid.
 */
export const parseOrderCurrencyConversionData = (currencyConversionData: unknown): CurrencyRateData | undefined => {
  if (!currencyConversionData) {
    return undefined;
  }

  try {
    const parsed = currencyRateDataSchema.validateSync(currencyConversionData, { strict: true });
    return parsed;
  } catch (error) {
    addError('Failed to parse order currency conversion data', { error, currencyConversionData });
    return undefined;
  }
};
